import { SUPPORT_EMAIL } from '@psyomics/ui-common';
import { Header, Text } from '@psyomics/ui-components';
import { Trans, useTranslation } from 'react-i18next';

import expiredLinkImage from '../../../../shared/assets/expired-link.svg';

const IntroText = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-[1em] mt-13">
      <Header level="h2">{t('page.viewReferral.linkExpired.header')}</Header>
      <Text size="lg" tag="p">
        <Trans
          components={{
            linkTag: (
              <a className="text-blue-500 underline" href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </a>
            ),
          }}
          i18nKey="page.viewReferral.linkExpired.body"
        />
      </Text>
    </div>
  );
};

const LinkExpiredIllustration = () => (
  <div>
    <img alt="Expired link illustration" src={expiredLinkImage} />
  </div>
);

const LinkExpired = () => {
  return (
    <div className="max-w-[680px] w-full mx-auto h-full pt-0 p-6">
      <div className="flex flex-col gap-[1em]">
        <IntroText />
        <div className="flex justify-center">
          <LinkExpiredIllustration />
        </div>
      </div>
    </div>
  );
};

export { LinkExpired };
